import { Link } from "react-router-dom";

/**
 * Standalone routines (one schedule per task slug) are retired: the scheduler
 * never runs them, so this page offers no schedule control for them. Recurring
 * work is a saved Action with its own Schedule.
 */
export function RetiredStandaloneSchedule({ brandId }: { brandId: string }) {
  return <section className="space-y-2">
    <h2 className="text-lg font-semibold">Schedule</h2>
    <p role="status" className="text-sm text-slate-700">
      This older schedule no longer runs. To run this Action on a schedule, save it as an Action and schedule the saved Action.
    </p>
    <Link className="text-sm text-brand-700 underline" to={`/brand/${encodeURIComponent(brandId)}/actions`}>Saved Actions</Link>
  </section>;
}
